const NotFoundPage = () => (
  <div className="errorPage has-text-centered">
    <h1>404</h1>
    <h2>Page Not Found</h2>
  </div>
);

export default NotFoundPage;
